export default __webpack_public_path__ + "16a3ecc57590b77782239562709c1f93.png";